<div class="informations">
  <div class="row">
    @if (reservation?.training?.type) {
      <span
        class="type badge badge-secondary"
      [ngClass]="{
        'badge-purple': reservation?.training?.type == trainingType.RECCURENT,
        'badge-green': reservation?.training?.type == trainingType.INITIAL,
        'badge-yellow': reservation?.training?.type == trainingType.SIMULATOR
      }"
        >
        {{ reservation?.training?.type }}
      </span>
    }
    <span class="date">
      @if (reservation?.startDate) {
        {{
        $safeNavigationMigration(reservation?.startDate) | date
        }}
      }
      @if (reservation?.endDate && !reservation?.isDry) {
        - {{ $safeNavigationMigration(reservation?.endDate) | date }}
      }
      @if (reservation?.isDry && reservation?.startDate) {
        / {{ $safeNavigationMigration(reservation?.startDate) | date: 'shortTime' }}
        @if (reservation?.endDate) {
          - {{ $safeNavigationMigration(reservation?.endDate) | date: 'shortTime' }}
        }
      }
    </span>
  </div>
  <div class="row">
    <div class="training">{{ reservation?.training?.name }}</div>
  </div>
  <div class="row">
    @if (reservation?.trainee?.name) {
      <span class="trainee">Trainee: {{ reservation?.trainee?.name }}</span>
    }
    @if (!reservation?.trainee?.name) {
      <span class="trainee no-name">No name attached</span>
    }
  </div>
</div>
@if (!isActive) {
  <div class="actions">
    <button class="select" (click)="selected()">
      <i class="icon icon-arrow-right"></i>
    </button>
  </div>
}
